<div class="flex h-full w-full items-center justify-center bg-proffeo-surface-page">
  <div class="flex flex-col items-center justify-center gap-5">
    <div class="flex items-center gap-4">
      <div class="flex items-center gap-2">
        <img
          src="img/logo/logo.png"
          alt="logo"
          class="w-11"
        />
        <p class="proffeo-ui-text-display">Proffeo</p>
      </div>
      <proffeo-lang-toggle></proffeo-lang-toggle>
    </div>
    <div class="min-w-90 md:max-w-[364px] flex items-center justify-center border-default bg-proffeo-surface p-8">
      <div class="flex w-full flex-col gap-2">
        <div class="flex w-full flex-col items-center justify-center gap-2">
          <p class="proffeo-ui-text-display text-center">
            {{ 'reset-password-reset-your-password' | translate }}
          </p>
          <p class="text-center">
            {{ 'reset-password-create-a-new-password-for-your-account' | translate }}
          </p>
        </div>

        <div
          [proffeoSpinner]="isLoading()"
          proffeoSpinnerSize="lg"
          class="relative min-h-48 w-full"
        >
          @if (!isLoading()) {
            @if (isLinkValid()) {
              <form
                [formRoot]="form"
                class="flex flex-col gap-4 pt-5"
              >
                <proffeo-ui-input
                  [formField]="form.newPassword"
                  label="reset-password-new-password"
                  type="password"
                  autocomplete="new-password"
                />

                <proffeo-ui-input
                  [formField]="form.newPasswordConfirm"
                  label="reset-password-new-password-confirm"
                  type="password"
                  autocomplete="new-password"
                />

                <div class="flex w-full items-center justify-center pt-3">
                  <proffeo-ui-button
                    (clicked)="onSubmitForm()"
                    [disabled]="form().submitting()"
                    variant="accent"
                    text="reset-password-reset-your-password"
                  ></proffeo-ui-button>
                </div>
              </form>
              <div class="flex flex-col items-center justify-center gap-2">
                @if (formStatus().isSuccess) {
                  <p class="text-base text-proffeo-success">
                    {{ 'reset-password-success' | translate }}
                  </p>
                  <p class="text-base font-light">
                    {{ 'reset-password-your-password-has-been-changed' | translate }}
                  </p>
                }

                @if (formStatus().isError) {
                  <p class="text-base text-proffeo-danger">
                    {{ 'reset-password-something-went-wrong-please-try-again-later-or-generate-a' | translate }}
                    <span
                      [routerLink]="['/forgot-password']"
                      class="text-base underline hover:opacity-75"
                    >
                      {{ 'reset-password-new-reset-password-link' | translate }}
                    </span>
                  </p>
                }
              </div>
            } @else {
              <div class="text-center flex flex-col gap-2 my-5">
                <p class="text-base text-proffeo-danger">
                  {{ 'reset-password-the-link-you-followed-has-expired' | translate }}
                </p>
                <p class="flex cursor-pointer items-center gap-1 text-base font-light">
                  {{ 'reset-password-please-generate-a' | translate }}
                  <span
                    [routerLink]="['/forgot-password']"
                    class="text-base underline hover:opacity-75"
                  >
                    {{ 'reset-password-new-reset-password-link' | translate }}
                  </span>
                </p>
              </div>
            }
          }
        </div>

        <div class="flex w-full flex-col items-center justify-center">
          <p
            routerLink="/sign-in"
            class="cursor-pointer text-sm hover:opacity-75"
          >
            Go back to Login...
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
